module.exports = __webpack_public_path__ + "static/media/dollar-not.175261e7.svg";